module.exports = __webpack_public_path__ + "static/media/reportCxcInvoicesStamp.c096920f.svg";